import { EntityDtoBase } from './Common'
import { EventContractorDto, EventOfContractorDto } from './Event'

export enum ContractorType {
    NotSet = 0,
    Brigadier = 1,
    Carrier = 2,
}

export interface ContractorDto extends EntityDtoBase {
    type: ContractorType
    name: string
    lastName: string
    note: string
    canBeAssigned: boolean
    emails: string[]
    phones: string[]
}

export interface CreateContractorDto extends Omit<ContractorDto, 'id' | 'createdAt' | 'events'> {}

export interface ContractorBriefDto extends Omit<ContractorDto, 'events' | 'contacts' | 'notifications' | 'address'> {
    emailCount: number
    phoneCount: number
    eventCount: number
    paidInTotal: number
    assignedEvents: EventOfContractorDto[]
}

/**
 * Contractor in the context of the event
 */
export interface ContractorOfEventDto extends EventContractorDto {
    /**
     * Contractor Id
     * Name of contractor will be resolved on frontend as list of available contractors must be ready there anyway for dropdown
     */
    contractorId?: string | null
}
